var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { StudyImageSectionNameLabels, } from "healthex-common/study.dtos";
import { isKeyOfObject, pick, willNeverHappen } from "healthex-common/utils";
import { computed, observable } from "mobx";
import { conflictFieldNames } from "./AddStudyConflictDetectionNames";
import { getFilePreviewInfo } from "../../FilePreview";
import { basename } from "healthex-common/utils";
import { TranscodeDto } from "healthex-common/transcode.dtos";
export class AddStudyConflictDetectionDialogModel {
    constructor(container) {
        this.previewOpen = false;
        this.filePreviewInfo = null;
        this.addProjectUIManager = container.addProjectUIManager;
    }
    get activeConflict() {
        const conflictedStudyInputKeys = Object.keys(this.addProjectUIManager.conflictedStudyInput);
        if (conflictedStudyInputKeys.length > 0) {
            const key = conflictedStudyInputKeys[0];
            let result;
            if (key === "additionalSections" && this.addProjectUIManager.conflictedStudyInput[key].length) {
                result = this.additionalSectionConflict(this.addProjectUIManager.conflictedStudyInput[key][0]);
            }
            else if (key === "hipaaAuthorizationForm" || key === "orgLogoOnInformedConsent") {
                result = this.studyFileConflict(key, this.addProjectUIManager.conflictedStudyInput[key]);
            }
            else if (key === "enrollmentVideo") {
                result = this.studyFileConflict(key, this.addProjectUIManager.conflictedStudyInput[key]);
            }
            else if (key === "timelineVisits") {
                result = this.studyTimelineConflict(this.addProjectUIManager.conflictedStudyInput[key]);
            }
            else if (key === "studySectionImages") {
                result = this.studySectionImageConflict(this.addProjectUIManager.conflictedStudyInput[key][0]);
            }
            else if (key === "studyTranslatableFields") {
                result = this.studyTranslatableFieldsConflict(this.addProjectUIManager.conflictedStudyInput[key]);
            }
            else {
                result = this.studyPropertyConflict(key, this.addProjectUIManager.conflictedStudyInput[key]);
            }
            return {
                key,
                field: conflictFieldNames[key],
                ...result,
            };
        }
        else {
            return null;
        }
    }
    studyPropertyConflict(key, theirValue) {
        const myValue = this.addProjectUIManager.studyFormModel.input[key];
        return {
            myValue: this.displayPropertyValue(myValue),
            theirValue: this.displayPropertyValue(theirValue),
            languageType: "CHANGE",
        };
    }
    studyFileConflict(key, theirValue) {
        const myValue = this.addProjectUIManager.studyFormModel.input[key];
        const displayFile = (fileValue) => {
            if (fileValue instanceof File) {
                return fileValue.name;
            }
            else if (fileValue instanceof TranscodeDto) {
                return basename(fileValue.sourceUrl);
            }
            else if (fileValue) {
                return basename(fileValue);
            }
            else {
                return "";
            }
        };
        let filetype;
        if (key === "hipaaAuthorizationForm") {
            filetype = "PDF";
        }
        else if (key === "orgLogoOnInformedConsent") {
            filetype = "IMAGE";
        }
        else if (key === "enrollmentVideo") {
            filetype = "VIDEO";
        }
        else {
            return willNeverHappen(key);
        }
        return {
            myValue: [displayFile(myValue)],
            theirValue: [displayFile(theirValue)],
            languageType: "FILE",
            myFilePreviewInfo: myValue ? getFilePreviewInfo(myValue, filetype) : undefined,
            theirFilePreviewInfo: theirValue ? getFilePreviewInfo(theirValue, filetype) : undefined,
        };
    }
    studyTimelineConflict(theirValue) {
        const myValue = this.addProjectUIManager.studyFormModel.input.timelineVisits;
        return {
            myValue: (myValue !== null && myValue !== void 0 ? myValue : []).flatMap((item) => [item.period, item.description, " "]),
            theirValue: theirValue.flatMap((item) => [item.period, item.description, " "]),
            languageType: "CHANGE",
        };
    }
    studySectionImageConflict(conflictedImage) {
        var _a, _b, _c;
        const myValue = this.addProjectUIManager.studyFormModel.input.studySectionImages;
        let myImage;
        let mySectionName;
        if (myValue && (conflictedImage === null || conflictedImage === void 0 ? void 0 : conflictedImage.id)) {
            for (const section of myValue) {
                const foundImage = section.images.find((img) => img.id === conflictedImage.id);
                if (foundImage) {
                    myImage = foundImage;
                    mySectionName = section.sectionName;
                    break;
                }
            }
        }
        const sectionName = (_a = mySectionName !== null && mySectionName !== void 0 ? mySectionName : conflictedImage === null || conflictedImage === void 0 ? void 0 : conflictedImage.sectionName) !== null && _a !== void 0 ? _a : "Unknown Section";
        const isCaptionConflicted = Boolean(conflictedImage.caption) && (myImage === null || myImage === void 0 ? void 0 : myImage.caption) !== conflictedImage.caption;
        const isImageConflicted = Boolean(conflictedImage.imageUrl) && (myImage === null || myImage === void 0 ? void 0 : myImage.imageUrl) !== conflictedImage.imageUrl;
        if (isCaptionConflicted && !isImageConflicted) {
            return {
                sectionName: StudyImageSectionNameLabels[sectionName],
                itemNumber: ((_b = myImage === null || myImage === void 0 ? void 0 : myImage.order) !== null && _b !== void 0 ? _b : 0) + 1,
                itemId: conflictedImage === null || conflictedImage === void 0 ? void 0 : conflictedImage.id,
                myValue: [`Caption: ${myImage === null || myImage === void 0 ? void 0 : myImage.caption}`],
                theirValue: [`Caption: ${conflictedImage.caption}`],
                languageType: "CHANGE",
            };
        }
        else {
            return {
                sectionName: StudyImageSectionNameLabels[sectionName],
                itemNumber: ((_c = myImage === null || myImage === void 0 ? void 0 : myImage.order) !== null && _c !== void 0 ? _c : 0) + 1,
                itemId: conflictedImage === null || conflictedImage === void 0 ? void 0 : conflictedImage.id,
                myValue: [`${myImage === null || myImage === void 0 ? void 0 : myImage.imageUrl}`],
                theirValue: [`${conflictedImage.imageUrl}`],
                languageType: "FILE",
                myFilePreviewInfo: (myImage === null || myImage === void 0 ? void 0 : myImage.imageUrl) ? getFilePreviewInfo(myImage.imageUrl, "IMAGE") : undefined,
                theirFilePreviewInfo: (conflictedImage === null || conflictedImage === void 0 ? void 0 : conflictedImage.imageUrl) ? getFilePreviewInfo(conflictedImage.imageUrl, "IMAGE") : undefined,
            };
        }
    }
    studyTranslatableFieldsConflict(theirValue) {
        var _a;
        const studyTranslatableFieldsKeys = Object.keys(theirValue).filter((key) => key !== "language");
        const myValue = this.addProjectUIManager.studyFormModel.input.studyTranslatableFields;
        return {
            myValue: this.displayPropertyValue((_a = myValue === null || myValue === void 0 ? void 0 : myValue[studyTranslatableFieldsKeys[0]]) !== null && _a !== void 0 ? _a : null),
            theirValue: this.displayPropertyValue(theirValue[studyTranslatableFieldsKeys[0]]),
            languageType: "CHANGE",
            field: conflictFieldNames[studyTranslatableFieldsKeys[0]],
            itemId: studyTranslatableFieldsKeys[0],
        };
    }
    displayPropertyValue(value) {
        if (Array.isArray(value)) {
            return value.map((singleValue) => this.displaySinglePropertyValue(singleValue));
        }
        else {
            return [this.displaySinglePropertyValue(value)];
        }
    }
    displaySinglePropertyValue(value) {
        const displayBoolean = (booleanValue) => (booleanValue ? "Yes" : "No");
        return typeof value === "boolean" ? displayBoolean(value) : String(value);
    }
    additionalSectionConflict(theirValue) {
        var _a;
        const additionalSections = this.addProjectUIManager.studyFormModel.input.additionalSections;
        const index = (_a = additionalSections === null || additionalSections === void 0 ? void 0 : additionalSections.findIndex((section) => section.id === theirValue.id)) !== null && _a !== void 0 ? _a : -1;
        const myValue = index === -1 ? undefined : additionalSections === null || additionalSections === void 0 ? void 0 : additionalSections[index];
        const itemNumber = index === -1 ? undefined : index + 1;
        const keys = ["title", "description"].filter((key) => isKeyOfObject(key, theirValue));
        return {
            itemNumber,
            itemId: theirValue.id,
            myValue: myValue ? Object.values(pick(myValue, ...keys)) : [],
            theirValue: Object.values(pick(theirValue, ...keys)),
            languageType: "CHANGE",
        };
    }
    get open() {
        return this.activeConflict !== null;
    }
    get title() {
        var _a, _b, _c, _d;
        const field = (_a = this.activeConflict) === null || _a === void 0 ? void 0 : _a.field;
        const sectionName = (_b = this.activeConflict) === null || _b === void 0 ? void 0 : _b.sectionName;
        const displayFieldName = sectionName ? `${sectionName} ${field}` : field;
        return `Conflict detected in '${displayFieldName}'${((_c = this.activeConflict) === null || _c === void 0 ? void 0 : _c.itemNumber) !== undefined ? ` #${(_d = this.activeConflict) === null || _d === void 0 ? void 0 : _d.itemNumber}` : ""} `;
    }
    get introText() {
        if (!this.activeConflict)
            return null;
        if (this.activeConflict.languageType === "CHANGE") {
            return "While you were editing this field, another team member made changes. You can review their selection and decide whether to keep them or override them with your own.";
        }
        else if (this.activeConflict.languageType === "FILE") {
            return "While you were uploading a file, another team member was also uploading a file. You can review their changes and decide whether to keep their file or override them with your own.";
        }
        else {
            return willNeverHappen(this.activeConflict.languageType);
        }
    }
    get theirLabel() {
        if (!this.activeConflict)
            return null;
        if (this.activeConflict.languageType === "CHANGE") {
            return "Their changes";
        }
        else if (this.activeConflict.languageType === "FILE") {
            return "Their file";
        }
        else {
            return willNeverHappen(this.activeConflict.languageType);
        }
    }
    get myLabel() {
        if (!this.activeConflict)
            return null;
        if (this.activeConflict.languageType === "CHANGE") {
            return "Your changes";
        }
        else if (this.activeConflict.languageType === "FILE") {
            return "Your file";
        }
        else {
            return willNeverHappen(this.activeConflict.languageType);
        }
    }
    async keepTheirChanges() {
        if (!this.activeConflict)
            return;
        await this.addProjectUIManager.keepTheirStudyChanges(this.activeConflict.key, this.activeConflict.itemId);
    }
    async keepMyChanges() {
        if (!this.activeConflict)
            return;
        await this.addProjectUIManager.keepMyStudyChanges(this.activeConflict.key, this.activeConflict.itemId);
    }
    showPreview(filePreviewInfo) {
        this.filePreviewInfo = filePreviewInfo;
        this.previewOpen = true;
    }
    closePreview() {
        this.previewOpen = false;
        this.filePreviewInfo = null;
    }
}
__decorate([
    observable
], AddStudyConflictDetectionDialogModel.prototype, "previewOpen", void 0);
__decorate([
    observable
], AddStudyConflictDetectionDialogModel.prototype, "filePreviewInfo", void 0);
__decorate([
    computed
], AddStudyConflictDetectionDialogModel.prototype, "activeConflict", null);
__decorate([
    computed
], AddStudyConflictDetectionDialogModel.prototype, "open", null);
__decorate([
    computed
], AddStudyConflictDetectionDialogModel.prototype, "title", null);
__decorate([
    computed
], AddStudyConflictDetectionDialogModel.prototype, "introText", null);
__decorate([
    computed
], AddStudyConflictDetectionDialogModel.prototype, "theirLabel", null);
__decorate([
    computed
], AddStudyConflictDetectionDialogModel.prototype, "myLabel", null);
